import { QueryMethods } from '../../enums/query-methods.enums';
import { PostQuery } from '../../@types/rtk-query';
import { ROUTES } from './account-plan.consts';

export const startTrial = (): PostQuery<undefined> => ({
  url: ROUTES.START_TRIAL,
  method: QueryMethods.Post,
});
